import * as angular from 'angular';
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.agents')
  .factory('$agentsPaymentCollection', AgentsPaymentCollection);

/* @ngInject */
function AgentsPaymentCollection($bringozFactory: $bringozFactory,
                                 AgentPaymentCollectionAPI: BringozApi,
                                 AgentPaymentCollection_DS: DataStoreConfig) {
  function $agentsPaymentCollection() {
    return $bringozFactory(null, AgentPaymentCollectionAPI, AgentPaymentCollection_DS);
  }

  return $agentsPaymentCollection;
}


